import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * RootRedirect Component
 * Componente de redirecionamento da rota raiz
 * Redireciona usuários para dashboard ou login baseado na autenticação
 */
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';
// ============================================================================
// Component
// ============================================================================
/**
 * RootRedirect
 *
 * Componente de redirecionamento inteligente para a rota raiz (/).
 * Direciona o usuário para a rota apropriada baseado no estado de autenticação.
 *
 * Comportamento:
 * - Se loading: Exibe spinner de carregamento
 * - Se autenticado: Redireciona para /app/inicio (dashboard)
 * - Se não autenticado: Redireciona para /app/login
 *
 * Uso típico:
 * - Montado na rota raiz "/" no React Router
 * - Garante que usuários sempre sejam direcionados corretamente
 *
 * @example
 * ```tsx
 * // Em App.tsx ou Router
 * <Route path="/" element={<RootRedirect />} />
 * ```
 */
export const RootRedirect = () => {
    const { isAuthenticated, loading } = useAuth();
    // Loading state - exibe spinner enquanto verifica autenticação
    if (loading) {
        return (_jsx("div", { className: "min-h-screen flex items-center justify-center bg-gradient-to-br from-[#1a1a1a] to-[#020202] transition-colors duration-300", children: _jsxs("div", { className: "text-center", children: [_jsx("div", { className: "animate-spin rounded-full h-12 w-12 border-b-2 border-icavi-500 mx-auto mb-4" }), _jsx("p", { className: "text-white text-lg", children: "Carregando..." })] }) }));
    }
    // Se está autenticado, vai para o dashboard
    if (isAuthenticated) {
        return _jsx(Navigate, { to: "/app/inicio", replace: true });
    }
    // Se não está autenticado, vai para o login
    return _jsx(Navigate, { to: "/app/login", replace: true });
};
export default RootRedirect;
